import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./index.css";
import { faUserCircle } from "@fortawesome/fontawesome-free-solid";
import { Box } from "@mui/material";
const opportunityLogo = `/assets/business-impact-opportunity.svg`;
const threatLogo = `/assets/business-impact-threat.svg`;
import { FaRegMessage } from "react-icons/fa6";
import { FaPlus } from "react-icons/fa6";
import { useCallback, useEffect, useState } from "react";
import { TextField } from "../../components/CustomFormElements/syncFusionFormFields";
import { useFormik } from "formik";
import * as Yup from "yup";
import BusinessImpactReply from "../BusinessImpactReply";
import moment from "moment";

const BusinessImpactComment = (props) => {
  const {
    userName,
    date,
    rating,
    commentText,
    id,
    showAddReply = true,
    replies = [],
    handleDeleteReplyClick,
    onSaveCommentClick,
    accessActionAddReply,
    loggedInUserId,
    isSaveDisabled,
    setIsSaveDisabled,
  } = props;
  const [showReplyBox, setShowReplyBox] = useState(false);

  const handleReplyClick = useCallback((id) => {
    if (!id) return;
    setShowReplyBox(true);
  });

  const formik = useFormik({
    initialValues: {
      reply: "",
    },
    validationSchema: Yup.object().shape({
      reply: Yup.string()
        .trim()
        .min(10, "Comment must be at least 10 characters.")
        .max(200, "You have exceeded the maximum limit of 200 characters.")
        .matches(/^(?=.*[A-Za-z])[A-Za-z\d!@#$%^&*()_+={}\[\]:;"'<>,.?/\\|`~\- ]/, "Please enter a valid comment.")
        .required("Comment must be at least 10 characters."),
    }),
  });

  const onSaveClick = () => {
    setIsSaveDisabled(true);
    formik.validateForm().then((res) => {
      if (Object.keys(res).length) {
        const touched = {};
        Object.keys(res).map((field) => {
          touched[field] = true;
          return touched;
        });
        formik.setFormikState({ ...formik, touched: touched, errors: res });
        setIsSaveDisabled(false);
      } else {
        let payload = formik.values;
        onSaveCommentClick(payload);
      }
    });
  };

  return (
    <div className="comment-wrapper">
      <div className="user-name-section">
        <FontAwesomeIcon icon={faUserCircle} style={{ fontSize: "24px", color: "#4B4B55" }} />
        <div>
          <div className="comment-heading">{userName}</div>
          <div className="comment-date-heading mt-1">{date}</div>
        </div>
      </div>
      <div className="comment-rating">
        <Box component="img" className="comment-rating-box" src={rating == "Opportunity" ? opportunityLogo : threatLogo} />
        <span className="comment-rating ml-1">{rating}</span>
      </div>
      <div>
        <div className="comment-rating">
          <FaRegMessage size={12} color="#4B4B55" />
          <span className="comment-title ml-1">Comment</span>
        </div>
        <div className="comment-text">
          {commentText}

          {showReplyBox && (
            <div className="comment-box-section">
              <TextField
                formik={formik}
                multiline={true}
                numberCount={true}
                maxLength={200}
                name="reply"
                className="reply-input"
                id="reply"
                placeholder="Reply"
                value={formik.values.reply || ""}
                htmlAttributes={{ rows: 4 }} // Set number of rows
              />
              <div className="comment-action-button">
                <button
                  type="button"
                  className="cy-test-btn btn btn-outline-dark"
                  onClick={() => {
                    formik.setFieldValue("reply", "");
                    formik.setTouched("reply", false);
                  }}
                >
                  Clear
                </button>
                <button type="button" className="btn btn-primary" disabled={isSaveDisabled} onClick={onSaveClick}>
                  Save
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
      {showAddReply && !showReplyBox && !replies?.length && accessActionAddReply && (
        <div className="comment-rating comment-reply" onClick={() => handleReplyClick(id)}>
          <FaPlus color={"#F94F5E"} size={16} />
          <span>Add Reply</span>
        </div>
      )}
      {replies?.length > 0 &&
        replies.map((r) => {
          return (
            <BusinessImpactReply
              userName={"FutureBridge Team"}
              date={moment(r?.commentCreatedDate).format("DD MMM YYYY")}
              commentText={r?.commentText || ""}
              handleDeleteReplyClick={handleDeleteReplyClick}
              id={r.id}
              accessActionAddReply={accessActionAddReply && loggedInUserId === r.commentCreatedByUserId}
            />
          );
        })}
    </div>
  );
};

export default BusinessImpactComment;
